export enum FactoryNodeVirtualChannelType {
    Number = "Number",
}